export const MEETING_DIVISION_MAP = {
  // New Friends Meeting → All divisions
  OTHER_MEETING_NEW_FRIENDS: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],

  // ✅ NEW: All India Study → All divisions
  OTHER_MEETING_ALL_INDIA_STUDY: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],

  // Education, Arts, Healthcare → Adult + Youth
  OTHER_MEETING_EDUCATION_DIVISION: ["MD", "WD", "YMD", "YWD"],
  OTHER_MEETING_ARTS_DIVISION: ["MD", "WD", "YMD", "YWD"],
  OTHER_MEETING_HEALTHCARE_DIVISION: ["MD", "WD", "YMD", "YWD"],

  // MD Pillar → MD only
  OTHER_MEETING_MD_PILLAR: ["MD"],
  OTHER_MEETING_SOURCE_OF_ORIGIN: ["WD"],
  // Campus Group → Youth only
  OTHER_MEETING_CAMPUS_GROUP: ["YMD", "YWD"],

  // ✅ NEW: Hope and Friendship → YWD only
  OTHER_MEETING_YWD_HOPE_AND_FRIENDSHIP_GATHERING: ["YWD"],

  // ✅ NEW: Vanguard Academy → YMD only
  OTHER_MEETING_YMD_VANGUARD_ACADEMY: ["YMD"],

  // Region SI meetings → All divisions (no filter)
  CUBS_MEETING: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],
  YP_MEETING: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],
  YL_MEETING: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],
  SD_MEETING: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],

  // Default for other types → show all
  DISCUSSION_MEETING: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],
  GOSHO_MEETING: ["MD", "WD", "YMD", "YWD", "FD(B)", "FD(G)"],
};

// Division sort order (MD → WD → YMD → YWD → FD(B) → FD(G))
export const DIVISION_SORT_ORDER = {
  MD: 1,
  WD: 2,
  YMD: 3,
  YWD: 4,
  "FD(B)": 5,
  "FD(G)": 6,
};
